import type { Account, ExpenseInput, Payee } from "../../types";
import DateInput from "../../components/DateInput";

export default function LoanTransactionFields({ input, field, account, payees }: {
  input: ExpenseInput;
  field: (key: keyof ExpenseInput, value: string) => void;
  account: Account | undefined;
  payees: Payee[];
}) {
  return <>
    <p className="settings-note">You can correct this transaction's date, description, time and notes here. Change the amount or account in the loan.</p>
    <label className="expense-amount">Amount <span>{account?.currency || "MVR"}</span>
      <input aria-label={`Amount in ${account?.currency || "MVR"}`} value={input.amount} disabled />
    </label>
    <label>Account<input value={account?.name || input.accountId} disabled /></label>
    <label>Payee<input value={payees.find(p => p.id === input.payeeId)?.name || ""} disabled /></label>
    <label>Category<input value={input.category} disabled /></label>
    <label>Description<input name="title" value={input.title} onChange={e => field("title", e.target.value)} required maxLength={160} /></label>
    <label>Date<DateInput value={input.date} onChange={e => field("date", e.target.value)} required /></label>
  </>;
}
